import { render, staticRenderFns } from "./saticilist.vue?vue&type=template&id=3271076b&"
import script from "./saticilist.vue?vue&type=script&lang=js&"
export * from "./saticilist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports